<template>
  <div>
    <h2>{{titulo}}</h2>
    <b-skeleton-img v-if="loading"></b-skeleton-img>
    <b-card title="Gráfico sin datos para mostrar" v-else-if="chartData.labels.length == 0"></b-card>
    <Doughnut
      v-else
      :chart-options="chartOptions"
      :chart-data="chartData"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
    </div>
</template>

<script>
import { formularioService, globales } from '@/services';
import { utils } from '@/helpers';
import { Doughnut } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  components: { Doughnut },
  props: {
    filtro: {},
    titulo: String,
    chartId: {
      type: String,
      default: 'torta-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      data: this.filtro,
      globales,
      loading: true,
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      chartOptions: {
        onClick: (e, context) => {
          console.log(e.chart);
          console.log(context);
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Estado formularios'
          },
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: 'white',
            borderRadius: 25,
            borderWidth: 2,
            color: 'white',
            font: {
              weight: 'bold'
            },
            formatter: function(value, context) {
              var dataset = context.dataset;
              var valor = dataset.data[context.dataIndex];
              let total = dataset.data.reduce((suma_parcial, a) => Number(suma_parcial) + Number(a), 0);
              total = total == 0 ? 1 : total;

              return Math.round(valor*100/total*10)/10 + '%';
            },
          }
        }
      }
    }
  },
  mounted(){
    if(typeof(this.filtro) === 'undefined'){
      this.data =  {
        id_nodo: utils.mapAtributo(this.$store.state.usuario.organizacion, 'id_nodo').toString(),
        fecha_i: new Date(2000,0,1),
        fecha_t: new Date(2030,0,1),
        estado:["'R'","'E'"],
        id_sucursal: this.$store.state.usuario.sucursales.map((element) => element.id_sucursal)
      }

      this.cargarDatos();
    }
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      formularioService.getGraficoTortaFormulario({
        id_usuario: this.$store.state.usuario.id_usuario,
        id_nodo: this.$store.state.usuario.usa_organizacion == 'S' ? this.data.id_nodo.split(",") : null,
        perfiles: utils.mapAtributo(this.$store.state.usuario.perfiles, 'id_perfil'), 
        id_sucursal: Array.isArray(this.data.id_sucursal) ? this.data.id_sucursal : this.data.id_sucursal.split(','),
        id_categoria: utils.mapAtributo(this.$store.state.usuario.categorias,'id_categoria'),
        fecha_i: utils.DateToFecha(this.data.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.data.fecha_t, 'dd-mm-yyyy'),
        estado: this.data.estado == null ? ["'R'","'E'","'T'","'V'"] : this.data.estado,
        campo: 'estado'
      }).then(data => {
        this.chartData.labels = [];
        this.chartData.datasets = [{backgroundColor:[],data:[]}];

        if(data.status == 'success'){
          data.data.forEach((element)=>{
            this.chartData.labels.push(this.descripcion(element[0]));
            this.chartData.datasets[0].data.push(element[1]);
            this.chartData.datasets[0].backgroundColor.push(this.color(element[0]));

          });
        }

        this.loading = false;
      });
    },
    descripcion(data){
      if(data == 'E'){
        return 'En ejecución';
      }
      if(data == 'R'){
        return 'Por asignar';
      }
      if(data == 'T'){
        return 'Terminado';
      }
      if(data == 'V'){
        return 'Verificado';
      }
    },
    color(data){
      if(data == 'E'){
        return '#1E90FF';
      }
      if(data == 'R'){
        return '#f8ac59';
      }
      if(data == 'T'){
        return '#4CAF50';
      }
      if(data == 'V'){
        return 'red';
      }
    },
  }
}
</script>

<style scoped>
</style>
